module.exports = __webpack_public_path__ + "static/media/kids_11.219f0b1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_11.jpg
// module id = 5867
// module chunks = 0